import { ActionTypes } from '../../actions/dashboard/members_index'

const {
  GET_MEMBERS,
  GET_MEMBERS_DATA,
  SET_IS_LOADING,
  GET_INITIAL_MEMBERS_DATA,
  ADD_NEW_GOLFER,
  EDIT_GOLFER,
  HIDE_MEMBER_POPUP,
  DELETE_MEMBER,
  SHOW_MEMBER_FORM_POPUP_NEW_GOLFER,
  SHOW_MEMBER_FORM_POPUP_EDIT_GOLFER,
  HIDE_MEMBER_FORM_POPUP,
} = ActionTypes

const initialState = {
  members: [],
  entryFees: 0,
  totalMembers: 0,
  leagueId: '',
  customerId: '',
  leagueName: '',
  paths: {},
  isLoading: false,
  loadedMembersCount: 0,
  teamIdMetadata: '',
  phoneMetadata: '',
  genderMetadata: '',
  needRefresh: false,
  membersLoaded: false,
  membersDataLoaded: false,
  showMemberPopup: false,
  memberPopupText: '',
  showMemberFormPopup: false,
  memberFormPopupText: '',
  memberFormAction: '',
  editMember: {},
}

const members = (state = initialState, action) => {
  switch (action.type) {
    case GET_MEMBERS: {
      return {
        ...state,
        members: [...state.members, ...action.data.members],
        loadedMembersCount: action.data.members.length,
      }
    }
    case GET_MEMBERS_DATA: {
      return {
        ...state,
        entryFees: action.data.entryFees,
        membersDataLoaded: true,
      }
    }

    case GET_INITIAL_MEMBERS_DATA: {
      return {
        ...state,
        ...action.data,
        loadedMembersCount: action.data.members.length,
        membersLoaded: true,
      }
    }
    case SET_IS_LOADING: {
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    }
    case ADD_NEW_GOLFER: {
      return {
        ...state,
        needRefresh: !state.needRefresh,
        showMemberPopup: true,
        memberPopupText: window.I18n.t('members.create.golfer_added_to_roster'),
      }
    }
    case HIDE_MEMBER_POPUP: {
      return {
        ...state,
        showMemberPopup: false,
        memberPopupText: '',
      }
    }
    case DELETE_MEMBER: {
      return {
        ...state,
        needRefresh: !state.needRefresh,
        showMemberPopup: true,
        memberPopupText: window.I18n.t('members.destroy.golfer_deleted_from_roster'),
      }
    }
    case EDIT_GOLFER: {
      return {
        ...state,
        needRefresh: !state.needRefresh,
        showMemberPopup: true,
        memberPopupText: window.I18n.t('members.update.golfer_updated'),
      }
    }
    case SHOW_MEMBER_FORM_POPUP_NEW_GOLFER: {
      return {
        ...state,
        showMemberFormPopup: true,
        memberFormPopupText: window.I18n.t('gg_golf_hub.member_form_popup.add_new_golfer'),
        memberFormAction: 'new',
      }
    }
    case SHOW_MEMBER_FORM_POPUP_EDIT_GOLFER: {
      const member = state.members[state.members.findIndex(item => item.id === action.data)]
      const editMemberHash = Object.fromEntries(
        Object.entries(member).map(([key, value]) => [key, value === '-' ? '' : value])
      )
      return {
        ...state,
        showMemberFormPopup: true,
        memberFormPopupText: window.I18n.t('gg_golf_hub.member_form_popup.edit_profile'),
        memberFormAction: 'edit',
        editMember: editMemberHash,
      }
    }
    case HIDE_MEMBER_FORM_POPUP: {
      return {
        ...state,
        showMemberFormPopup: false,
        memberFormPopupText: '',
        memberFormAction: '',
        editMember: {},

      }
    }
    default:
      return state
  }
}

export default members
